import * as fromDatatype from "../../../datatype-library";

export class GetUserAppletLinksModel {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_link_guid: fromDatatype.GuidDataFieldInterface;
  user_applet_index: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.VarcharDatatypeClass;
  applet: Applet;
  catalog: Catalog;
  tenant: Tenant;
  store: Store;
  isStore: boolean;
  user_applet_rank: fromDatatype.VarcharDatatypeInterface;
  notification_count: fromDatatype.NumericDatatypeInterface;
}

export class Applet {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_mf_html_tag: fromDatatype.VarcharDatatypeClass;
  applet_code: fromDatatype.VarcharDatatypeClass;
  applet_shortcode: fromDatatype.VarcharDatatypeClass;
  applet_name: fromDatatype.VarcharDatatypeClass;
  applet_icon_guid?: fromDatatype.VarcharDatatypeClass;
  es_module_url: fromDatatype.VarcharDatatypeClass;
  routerlink: fromDatatype.VarcharDatatypeClass;
  status: fromDatatype.VarcharDatatypeClass;
  applet_description: fromDatatype.VarcharDatatypeClass;
  store_guid: fromDatatype.GuidDataFieldInterface;
}

export class Catalog {
  guid: fromDatatype.GuidDataFieldInterface;
  catalog_code: fromDatatype.VarcharDatatypeClass;
  catalog_name: fromDatatype.VarcharDatatypeClass;
  status: fromDatatype.VarcharDatatypeClass;
}

export class Tenant {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeClass;
  tenant_name: fromDatatype.VarcharDatatypeClass;
  status: fromDatatype.VarcharDatatypeClass;
}

export class Store {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeClass;
  name: fromDatatype.VarcharDatatypeClass;
}
